<template>
  <div>
    {{ field?.label }}
  </div>

  <GenericFormLayout
    ref="fieldsLayoutRef"
    v-model="formData"
    :dense="dense"
    :errors="formErrors"
    :fields="fields"
    :rules="formRulesMap"
  />
</template>

<script setup lang="ts">
import { GenericFormLayout } from '#components';

const props = defineProps<{
  modelValue: Vehicle
  dense?: boolean
  field?: FieldConfig
}>();

const emit = defineEmits(['update:modelValue']);
const { getVehicleFormConfig } = useFieldConfigsVehicle();
const fields = await getVehicleFormConfig();

const fieldsLayoutRef = ref<InstanceType<typeof GenericFormLayout>>();

const {
  data: formData,
  rules: formRulesMap,
  errors: formErrors,
} = useSetupFormFromFields({
  fields,
  initialData: props.modelValue,
});

watch(() => formData, newData => {
  emit('update:modelValue', newData);
}, { deep: true });
</script>
